import React from 'react';
import type { TCAction } from 'src/api/generated';
import { Text } from 'src/modules/shared/components/atoms/text';
import { ListItemSkeleton } from 'src/modules/shared/components/atoms/lists/list-item-skeleton';
import Modal from 'src/modules/shared/components/molecules/modals/modal';

type WorkflowActionPickerModalProps = {
  isOpen: boolean;
  onClose: () => void;
  pendingFinal: boolean;
  actionSearch: string;
  onActionSearchChange: (value: string) => void;
  actions: TCAction[];
  loading: boolean;
  onSelectAction: (action: TCAction) => void;
};

export const WorkflowActionPickerModal: React.FC<
  WorkflowActionPickerModalProps
> = ({
  isOpen,
  onClose,
  pendingFinal,
  actionSearch,
  onActionSearchChange,
  actions,
  loading,
  onSelectAction,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    header={
      <div className="flex flex-col gap-1">
        <Text as="h3" weight="medium" className="text-slate-900">
          Seleccionar acción
        </Text>
        <Text size="tiny" className="text-slate-600">
          {pendingFinal
            ? 'Crea el paso final del flujo (solo puede existir uno).'
            : 'Agrega un nuevo paso conectado al actual.'}
        </Text>
      </div>
    }
    body={
      <div className="w-full space-y-3">
        <input
          className="border rounded px-2 py-1.5 text-sm w-full"
          placeholder="Buscar acción…"
          value={actionSearch}
          onChange={(e) => onActionSearchChange(e.target.value)}
        />
        {loading ? (
          <div className="max-h-[60vh] overflow-auto pr-1">
            <ListItemSkeleton />
          </div>
        ) : (
          <div className="space-y-2 max-h-[60vh] overflow-auto pr-1">
            {actions.map((act) => (
              <button
                key={act.name}
                type="button"
                className="w-full text-left border rounded px-3 py-2 hover:border-primary-400 hover:bg-primary-50 transition"
                onClick={() => onSelectAction(act)}
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <Text weight="medium" className="text-slate-900">
                      {act.annotations?.title || act.name}
                    </Text>
                    <Text size="tiny" className="text-slate-500 truncate">
                      {act.name}
                    </Text>
                    {act.description && (
                      <Text size="tiny" className="text-slate-600 line-clamp-2">
                        {act.description}
                      </Text>
                    )}
                  </div>
                </div>
              </button>
            ))}
            {actions.length === 0 && (
              <div className="text-sm text-slate-500 px-1">
                No hay acciones que coincidan.
              </div>
            )}
          </div>
        )}
      </div>
    }
  />
);

export default WorkflowActionPickerModal;
